<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="គណនីអ្នកគ្រប់គ្រងទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតគណនីអ្នកគ្រប់គ្រងថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះចូលប្រព័ន្ធ</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>លេខទូរស័ព្ទ</md-table-head>
					<md-table-head>ប្រភេទគណនី</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(admin, index) in adminList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>{{ admin.username }}</md-table-cell>
					<md-table-cell>{{ admin.name }}</md-table-cell>
					<md-table-cell>{{ admin.phone_number }}</md-table-cell>
					<md-table-cell>{{ config.getAdminType(admin.account_type) }}</md-table-cell>
					<md-table-cell>{{ config.datelify(admin.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/administrators/edit/' + admin.admin_id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែ</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(admin.admin_id)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុប</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ឈ្មោះពេញ</label>
						<md-input v-model="admin.name" type="text" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>លេខទូរស័ព្ទ</label>
						<md-input v-model="admin.phoneNumber" type="number" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ឈ្មោះចូលប្រព័ន្ធ</label>
						<md-input v-model="admin.username" type="text" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ប្រភេទគណនី</label>
						<md-select placeholder="ប្រភេទគណនី" v-model="admin.account_type" @md-selected="checkValidation()">
							<md-option value="ad">អ្នកគ្រប់គ្រងទូទៅ</md-option>
							<md-option value="sa">អ្នកគ្រប់គ្រងជាន់ខ្ពស់</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ពាក្យសំងាត់</label>
						<md-input v-model="admin.password" type="password" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>បញ្ជាក់ពាក្យសំងាត់</label>
						<md-input v-model="admin.confirmPassword" type="password" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>

				<div class="md-layout-item md-size-100 text-right">
					<md-button :class="{'md-raised': true, 'md-primary': isValid}" @click="postAdmin()" :disabled="!isValid">បង្កើតថ្មី</md-button>
				</div>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="dialogActive" md-title="តើអ្នកពិតជាចង់លុបគណនីនេះមែនឬ ?" md-content="ដោយចុច OK គណនីនេះនឹងត្រូវបានលុបជារៀងរហូត។" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel"
		   @md-confirm="onDelete" />
	</div>
</template>

<script>
	export default {
		created() {
			this.getAdmin();
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				dialogActive: false,
				deleteSelected: '',
				isValid: false,
				adminList: [],
				renderComponent: true,
				admin: {
					name: "",
					phoneNumber: "",
					username: "",
					password: "",
					confirmPassword: "",
					account_type: ""
				}
			}
		},
		methods: {
			getAdmin(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/admin/get/list/" + offset).then(data => {

					this.adminList = replace ? data.body.data : this.adminList.concat(data.body.data)
					this.loaded = true;

				})
			},
			loadMore() {
				this.getAdmin(this.adminList.length, false);
			},
			postAdmin() {
				let name = this.admin.name
				let phoneNumber = this.admin.phoneNumber
				let username = this.admin.username
				let password = this.admin.password
				let account_type = this.admin.account_type

				this.clear()
				this.checkValidation()

				this.$http.post(this.config.api + "/admin/admin/post", {
					username,
					name,
					password,
					phoneNumber,
					account_type
				}).then(res => {
					if (res.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "គណនីត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getAdmin();
					}
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.dialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/admin/delete", {
					admin_id: this.deleteSelected
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "គណនីត្រូវបានលុបដោយជោគជ័យ",
							icon: 'done',
							type: 'success'
						})
						this.getAdmin();
						this.dialogActive = false
					}
				})


			},
			onCancel() {
				this.deleteSelected = ""
				this.dialogActive = false
			},
			checkValidation() {
				this.admin.username = this.config.validateUsername(this.admin.username);
				if (this.admin.name.length > 3 &&
					this.admin.phoneNumber.length > 8 &&
					this.admin.username.length > 3 &&
					this.config.validateUsername(this.admin.username) == this.admin.username &&
					this.admin.password.length > 6 &&
					this.admin.confirmPassword.length > 6 && this.admin.password == this.admin.confirmPassword) {
					this.isValid = true
				} else {
					this.isValid = false
				}
			},
			clear() {
				this.admin.name = ""
				this.admin.phoneNumber = ""
				this.admin.username = ""
				this.admin.password = ""
				this.admin.confirmPassword = ""
			},
			forceRerender() {
				// Remove my-component from the DOM
				this.renderComponent = false;

				this.$nextTick(() => {
					// Add the component back in
					this.renderComponent = true;
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Administrators/View.vue